<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Enter your details</div>
      <form [formGroup]='userForm' (ngSubmit)="onSubmit()">
        <label for="firstName">First Name*</label>
        <br>
        <input type="text" placeholder="Enter First Name" required name="firstName" id="firstName" [formControl]="firstName">
        <small *ngIf="userForm.get('firstName').hasError('required') && userForm.get('firstName').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
          *ngIf='!toggleEditStyles[1]'>edit</i> -->
        <br>
        <label for="lastName">Last Name*</label>
        <br>
        <input type="text" placeholder="Enter Last Name" name="lastName" id="lastName" [formControl]="lastName">
        <small *ngIf="userForm.get('lastName').hasError('required') && userForm.get('lastName').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[2]=true'
          *ngIf='!toggleEditStyles[2]'>edit</i> -->
        <br>
        <label for="firstName">Username*</label>
        <br>
        <input type="text" placeholder="Enter Username" required name="qID" id="qID" minlength="8" maxlength="60" [formControl]="qID">
        <small *ngIf="userForm.get('qID').hasError('required') && userForm.get('qID').touched">Required</small>
        <!--<small *ngIf="userForm.get('qID').hasError('minlength') && userForm.get('qID').touched">Username must be at least 8 characters long</small>
        <small *ngIf="userForm.get('qID').hasError('maxlength') && userForm.get('qID').touched">Username can be max 60 characters long</small> -->
		    <small *ngIf="userForm.get('qID').hasError('pattern')">User name is not valid.</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
          *ngIf='!toggleEditStyles[1]'>edit</i> -->
        <br>
        <label for="firstName">Password*</label>
        <br>
        <input type="password" (input)='checkPasswordStrength()' placeholder="Enter Password" required name="password" id="password"
         minlength="8" maxlength="32" [formControl]="password">
        <small *ngIf="userForm.get('password').hasError('required') && userForm.get('password').touched">Required</small>
        <small *ngIf="userForm.get('password').hasError('minlength') && userForm.get('password').touched">Password must be at least 8 characters long</small>
        <small *ngIf="userForm.get('password').hasError('maxlength') && userForm.get('password').touched">Password can be max 32 characters long</small>
        <div id="strength" #strength>
          <ul id="strengthBar">
            <li class="point" [style.background-color]="bar0"></li>
            <li class="point" [style.background-color]="bar1"></li>
            <li class="point" [style.background-color]="bar2"></li>
          </ul>
        </div>
        <div class="bmw-password-policy">
          <ul>
            <li>8 Characters minimum</li>
            <li>1 Lowercase character</li>
            <li>No sequencing</li>
            <li>1-4 Numbers</li>
            <li>Symbol '#' or '$'</li>
          </ul>
        </div>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
          *ngIf='!toggleEditStyles[1]'>edit</i> -->
        
        <label for="confirmPassword">Confirm Password*</label>
        <br>
        <input type="password" placeholder="ReEnter Password" required name="confirmPassword" id="confirmPassword"[formControl]="confirmPassword">
        <small *ngIf="userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched">Required</small>
        <br>
        <label for="companyName">Company Name</label>
        <br>
        <input type="text" placeholder="Enter Company Name" name="companyName" id="companyName" [formControl]="companyName">
        <!--<small *ngIf="userForm.get('companyName').hasError('required') && userForm.get('companyName').touched">Required</small>-->
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[3]=true'
          *ngIf='!toggleEditStyles[3]'>edit</i> -->
        <br>
        <label for="address1">Address 1*</label>
        <br>
        <input type="text" placeholder="Enter Address 1" name="address1" id="address1" [formControl]="address1">
        <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[4]=true'
          *ngIf='!toggleEditStyles[4]'>edit</i> -->
        <br>
        <label for="address2">Address 2</label>
        <br>
        <input type="text" placeholder="Enter Address 2" name="address2" id="address2" [formControl]="address2">
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[5]=true'
          *ngIf='!toggleEditStyles[5]'>edit</i> -->
        <br>
        <label for="city">City*</label>
        <br>
        <input type="text" placeholder="Enter City" name="city" id="city" [formControl]="city">
        <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[6]=true'
          *ngIf='!toggleEditStyles[6]'>edit</i> -->
        <br>
        <label for="state">State/Province/Territory*</label>
        <br>
        <input type="text" placeholder="Enter State/Province/Territory" name="state" id="state" [formControl]="state">
        <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[7]=true'
          *ngIf='!toggleEditStyles[7]'>edit</i> -->
        <br>
        <label for="zipCode">Zip/Postal Code*</label>
        <br>
        <input type="text" placeholder="Enter Zipcode" name="zipCode" id="zipCode" [formControl]="zipCode">
        <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[8]=true'
          *ngIf='!toggleEditStyles[8]'>edit</i> -->
        <br>
        <label for="phone">Phone*</label>
        <br>
        <input type="text" placeholder="(___) ___-____" [imask]="phoneMask" name="phone" id="phone" [formControl]="phone">
        <small *ngIf="userForm.get('phone').hasError('required') && userForm.get('phone').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[9]=true'
          *ngIf='!toggleEditStyles[9]'>edit</i> -->
        <br>
        <label for="email">Email*</label>
        <br>
        <input type="text" placeholder="someone@example.com" name="email" id="email" [formControl]="email">
        <small *ngIf="userForm.get('email').hasError('required') && userForm.get('email').touched">Required</small>
        <small *ngIf="userForm.get('email').hasError('pattern')">Enter valid email</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[10]=true'
          *ngIf='!toggleEditStyles[10]'>edit</i> -->
          <br>
          <label for="reEnterEmail">Re-Enter Email*</label>
          <br>
          <input type="text" placeholder="someone@example.com" name="reEnterEmail" id="reEnterEmail" [formControl]="reEnterEmail">
          <small *ngIf="userForm.get('reEnterEmail').hasError('required') && userForm.get('reEnterEmail').touched">Required</small>
          <br>
          <br>
          <small>{{errorMessage}}</small>
          <br>
          <br>
        <button type='submit' [disabled]='userForm.invalid || checkPasswordStrength() < 3' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
          class="bmw-submit-button" style="padding:7px;margin-top:70px">Sign Up</button>
      </form>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">Enter your details</div>
      <form [formGroup]='userForm' (ngSubmit)="onSubmit()">
        <label for="firstName">First Name*</label>
        <br>
        <input type="text" placeholder="Enter First Name" required name="firstName" id="firstName" [formControl]="firstName">
        <small *ngIf="userForm.get('firstName').hasError('required') && userForm.get('firstName').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
            *ngIf='!toggleEditStyles[1]'>edit</i> -->
        <br>
        <label for="lastName">Last Name*</label>
        <br>
        <input type="text" placeholder="Enter Last Name" name="lastName" id="lastName" [formControl]="lastName">
        <small *ngIf="userForm.get('lastName').hasError('required') && userForm.get('lastName').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[2]=true'
            *ngIf='!toggleEditStyles[2]'>edit</i> -->
        <br>
        <label for="qID">Username*</label>
        <br>
        <input type="text" placeholder="Enter Username" required name="qID" id="qID" minlength="8" maxlength="60" [formControl]="qID">
        <small *ngIf="userForm.get('qID').hasError('required') && userForm.get('qID').touched">Required</small>
        <small *ngIf="userForm.get('qID').hasError('minlength') && userForm.get('qID').touched">Username must be at least 8 characters long</small>
        <small *ngIf="userForm.get('qID').hasError('maxlength') && userForm.get('qID').touched">Username can be max 60 characters long</small>
		<small *ngIf="userForm.get('qID').hasError('pattern')">User name is not valid.</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
            *ngIf='!toggleEditStyles[1]'>edit</i> -->
        <br>
        <label for="password">Password*</label>
        <br>
        <input type="password" autocomplete="off" (input)='checkPasswordStrength()' placeholder="Enter Password" required name="password" id="password"
         minlength="8" maxlength="32" [formControl]="password">
        <small *ngIf="userForm.get('password').hasError('required') && userForm.get('password').touched">Required</small>
        <small *ngIf="userForm.get('password').hasError('minlength') && userForm.get('password').touched">Password must be at least 8 characters long</small>
        <small *ngIf="userForm.get('password').hasError('maxlength') && userForm.get('password').touched">Password can be max 32 characters long</small>
        <div id="strength" #strength>
          <ul id="strengthBar">
            <li class="point" [style.background-color]="bar0"></li>
            <li class="point" [style.background-color]="bar1"></li>
            <li class="point" [style.background-color]="bar2"></li>
          </ul>
        </div>
        <div class="bmw-password-policy">
          <ul>
            <li>8 Characters minimum</li>
            <li>1 Lowercase character</li>
            <li>No sequencing</li>
            <li>1-4 Numbers</li>
            <li>Symbol '#' or '$'</li>
          </ul>
        </div>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[1]=true'
            *ngIf='!toggleEditStyles[1]'>edit</i> -->
        <label for="confirmPassword">Confirm Password*</label>
        <br>
        <input type="password" placeholder="ReEnter Password" required name="confirmPassword" id="confirmPassword"[formControl]="confirmPassword">
        <small *ngIf="userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched">Required</small>
        <br>
        <label for="companyName">Company Name</label>
        <br>
        <input type="text" placeholder="Enter Company Name" name="companyName" id="companyName" [formControl]="companyName">
        <small *ngIf="userForm.get('companyName').hasError('required') && userForm.get('companyName').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[3]=true'
            *ngIf='!toggleEditStyles[3]'>edit</i> -->
        <br>
        <label for="address1">Address 1*</label>
        <br>
        <input type="text" placeholder="Enter Address 1" name="address1" id="address1" [formControl]="address1">
        <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[4]=true'
            *ngIf='!toggleEditStyles[4]'>edit</i> -->
        <br>
        <label for="address2">Address 2</label>
        <br>
        <input type="text" placeholder="Enter Address 2" name="address2" id="address2" [formControl]="address2">
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[5]=true'
            *ngIf='!toggleEditStyles[5]'>edit</i> -->
        <br>
        <label for="city">City*</label>
        <br>
        <input type="text" placeholder="Enter City" name="city" id="city" [formControl]="city">
        <small *ngIf="userForm.get('address1').hasError('city') && userForm.get('city').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[6]=true'
            *ngIf='!toggleEditStyles[6]'>edit</i> -->
        <br>
        <label for="state">State/Province/Territory*</label>
        <br>
        <input type="text" placeholder="Enter State/Province/Territory" name="state" id="state" [formControl]="state">
        <small *ngIf="userForm.get('address1').hasError('state') && userForm.get('state').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[7]=true'
            *ngIf='!toggleEditStyles[7]'>edit</i> -->
        <br>
        <label for="zipCode">Zip/Postal Code*</label>
        <br>
        <input type="text" placeholder="Enter Zipcode" name="zipCode" id="zipCode" [formControl]="zipCode">
        <small *ngIf="userForm.get('address1').hasError('zipCode') && userForm.get('zipCode').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[8]=true'
            *ngIf='!toggleEditStyles[8]'>edit</i> -->
        <br>
        <label for="phone">Phone*</label>
        <br>
        <input type="text" placeholder="(___) ___-____" [imask]="phoneMask" name="phone" id="phone" [formControl]="phone">
        <small *ngIf="userForm.get('address1').hasError('phone') && userForm.get('phone').touched">Required</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[9]=true'
            *ngIf='!toggleEditStyles[9]'>edit</i> -->
        <br>
        <label for="email">Email*</label>
        <br>
        <input type="text" placeholder="someone@example.com" name="email" id="email" [formControl]="email">
        <small *ngIf="userForm.get('email').hasError('required') && userForm.get('email').touched">Required</small>
        <small *ngIf="userForm.get('email').hasError('pattern')">Enter valid email</small>
        <!-- <i [ngStyle]='{"color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[10]=true'
            *ngIf='!toggleEditStyles[10]'>edit</i> -->
        <br>
        <label for="reEnterEmail">Re-Enter Email*</label>
        <br>
        <input type="text" placeholder="someone@example.com" name="reEnterEmail" id="reEnterEmail" [formControl]="reEnterEmail">
        <small *ngIf="userForm.get('reEnterEmail').hasError('required') && userForm.get('reEnterEmail').touched">Required</small>
        <br>
        <br>
        <small>{{errorMessage}}</small>
        <br>
        <br>
        <button type='submit' [disabled]='userForm.invalid || checkPasswordStrength() < 3' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
          class="bmw-submit-button" style="padding:7px;margin-top:70px">Sign Up</button>
      </form>
      <!-- <div [routerLink]='["/profile"]' class="bmw-button-secondary bmw-xs pointer">Back</div> -->
    </div>
    </div>
</div>